export default function FAQ() {
  const faqs = [
    { q: "What time is check‑in/out?", a: "Check‑in 2pm, check‑out 11am." },
    { q: "Is breakfast included?", a: "Breakfast is an optional add‑on." },
    { q: "Is parking available?", a: "Yes, free parking on site." },
    { q: "Quiet hours?", a: "10pm–7am. Please respect other guests." },
  ];
  return (
    <section className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-semibold tracking-tight mb-6">FAQs</h1>
      <div className="space-y-6">
        {faqs.map((f) => (
          <div key={f.q}>
            <h3 className="font-medium">{f.q}</h3>
            <p className="text-sm text-muted-foreground mt-1">{f.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
